








import { Component, Vue } from 'vue-property-decorator'
import './style.less'

@Component
export default class Warning extends Vue {
  constructor () {
    super()

    console.info('📦 [Warning] componentDidMount....')
  }
}
